import { useState, useEffect, useRef } from 'react';
import { TrendingUp, Briefcase } from 'lucide-react';
import { useLanguage } from '@/lib/LanguageContext';
import ClientLogo from './ClientLogo';
import { CLIENT_LOGOS as clients } from '@/lib/clientLogos';

export default function SuccessCarousel() {
  const { t } = useLanguage();
  const [paused, setPaused] = useState(false);
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);
  const items = [...clients, ...clients];

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => setInView(entries[0].isIntersecting),
      { rootMargin: '100px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-[#F9FAFB] border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-gray-400 text-xs font-bold uppercase tracking-widest mb-8 flex items-center justify-center gap-2">
          <TrendingUp size={14} className="text-gray-300" />
          {t('success.label')}
          <Briefcase size={14} className="text-gray-300" />
        </p>
        <div
          className="overflow-hidden relative"
          aria-label={t('aria.clientCarousel')}
          style={{
            maskImage: 'linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)',
            WebkitMaskImage: 'linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)',
          }}
        >
          <div
            className="flex gap-10 w-max will-animate"
            style={{
              animation: 'success-marquee 40s linear infinite',
              animationPlayState: paused || !inView ? 'paused' : 'running',
            }}
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
          >
            {items.map((client, i) => (
              <div
                key={i}
                className="flex flex-col items-center justify-center shrink-0 h-16 px-4 gap-1.5"
              >
                <ClientLogo
                  domain={client.domain}
                  name={client.name}
                  className="h-10 w-10 object-contain opacity-50 grayscale"
                />
                <span className="font-heading font-bold text-gray-300 text-xs whitespace-nowrap select-none">
                  {client.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}